export enum InventoryElevation {
    GROUND_SITE = "Ground Site",
    ROOF_TOP = "Roof Top"
}